import type { ResAllType } from '../../Types/Api/All'
import type { DocumentData, SaveDocumentReq } from '../../Types/Api/Document'
import type { OKRes } from '../../Types/Api/Ok'
import { api } from './API'
import { requireAuth } from './Auth'

interface IConditions {
  start_date: string | null
  end_date: string | null
  s: string
}

//
// 資料
//

export const searchDocuments = async (
  page: number,
  conditions?: IConditions | string,
  per_page?: number,
  request_source?: 'lead',
) => {
  return await requireAuth<ResAllType<DocumentData>>(
    api.get('documents', { page, conditions, per_page, request_source }),
  )
}

export const findDocumentID = (id: number) => {
  return requireAuth<DocumentData>(api.get(`documents/${id}`))
}

export const createDocument = async (values: FormData) => {
  return requireAuth<OKRes>(api.post(`documents`, values))
}

export const deleteDocument = (id: number) => {
  return requireAuth<string>(api.delete(`documents/${id} `))
}

export const editDocument = async (
  values: SaveDocumentReq | FormData,
  id: number,
) => {
  return requireAuth<OKRes>(api.post(`documents/${id}`, values))
}

export const downloadDocument = async () => {
  const res = await requireAuth<any>(api.get(`documents`))
  return res.data
}

export const findAllDocument = async () => {
  return await requireAuth<any>(api.get('documents', { query_type: 'all' }))
}
